(ns hai.admin-ui.data-tasks.routes
  "Describes data tasks routing (reitit)."
  (:require
   [hai.ui.components :as c]
   [hai.web-app.layout :as layout]
   [hai.web-app.routing :as routing]
   [hai.ui.icons :as icons]
   [hai.ui.rf-sugar :refer [<s >e >e! defevent]]))

;; NOTE (evgheni): these views are placeholders for the walking skeleton
;; The actual views will probably live in their respective namespaces with the related
;; functionality.

(def icon icons/task)

(defn all-tasks-view
  []
  [layout/page
   [layout/title-bar
    [c/Heading "All Data Tasks"]
    [c/Button
     {:on-click #(>e [:routing/navigate [:data-tasks/new]])}
     "+ Create"]]])

(defn new-task-view
  []
  [layout/page
   [layout/title-bar
    [c/Heading "Choose Template... Or Not"]]
   [:div "Templates and stuff"]
   [c/Button
     {:on-click #(>e [:routing/navigate [:data-tasks-new/connection]])}
     "Go to Connection Setup"]])

(defn connection-setup-view
  []
  [layout/page
   [layout/title-bar
    [c/Heading "Connect to your thing"]]
   [:div [:h1 {:style {:margin-left "20px" :background-color "#fcc" :font-size "1.5em" :font-weight "bold" :width "600px"}}
    "Select a connection to access your data"]]
   (let [connections #:user {:connections [#:connection {:uuid        #uuid "20188b6e-bde4-4eb8-b59a-07b36d09fd93",
                                                         :type        :notion,
                                                         :description "Notion - 11:03 2025-Jul-22"}
                                           #:connection {:uuid        #uuid "ad2fd7c0-8175-4d48-adfe-3dbd8846b262",
                                                         :type        :airtable,
                                                         :description " — Matta , gingerbread BD, and others"}
                                           #:connection {:uuid        #uuid "3f1b6636-64d6-4c18-8307-1a1b381b76a5",
                                                         :type        :airtable,
                                                         :description "hannah.smith@thehumbleai.com — QA | Field Support Testing | Humble Internal"}]}
         bases #:airtable
                       {:bases                [#:airtable.base {:id "appfn4f4Ux90NITdY", :name "Matta "}
                                               #:airtable.base {:id "app2dFDTh7n9X4b4F", :name "gingerbread BD"}
                                               #:airtable.base {:id "appT7m8v1uVE7OYfm", :name "Forms for website - candidate & employer"}
                                               #:airtable.base {:id "appMN2mRPvnjqu9Uh", :name "CLIENT DATABASE TEMPLATE (TEST))"}
                                               #:airtable.base {:id "app56AFHSK4u4ndu0", :name "CLIENT DATABASE TEMPLATE"}
                                               #:airtable.base {:id "appDDjGTvkUTUkPDS", :name "GB CLIENT TEMPLATE - KANBAN - V1"}
                                               #:airtable.base {:id "app4BANTTH6Itm0Rp", :name "Capi Money "}
                                               #:airtable.base {:id "apppBBEMMkZ8k2Wr1", :name "Team Capacity"}
                                               #:airtable.base {:id "apphhhsxbC02c4EyP", :name "Granite Oak"}
                                               #:airtable.base {:id "app6Ud6c9rNnrCAVd", :name "9 Communications (Charlotte version)"}
                                               #:airtable.base {:id "app9C5wnI4gdjYBjT", :name "Nine Communications Private "}
                                               #:airtable.base {:id "appOSSGPjimJcyV35", :name "Turintech AI"}
                                               #:airtable.base {:id "appENjav3X2p3T0Cx", :name "Energy Drive Solutions"}
                                               #:airtable.base {:id "appZvWjoF3dnlvKQL", :name "Moghrabi Family Office"}
                                               #:airtable.base {:id "apps26Ni1TLTbYsSo", :name "Liddy AI"}
                                               #:airtable.base {:id "appgimD86QGSjAgZG", :name "Sturgeon Capital Portfolio form"}
                                               #:airtable.base {:id "app7QHwmt5TdKY5vo", :name "Ex- Meta"}
                                               #:airtable.base {:id "appzz0mI7Q1GiI0G5", :name "Phagos"}
                                               #:airtable.base {:id "appEewP4xLXrAafKF", :name "Sony Innovation Fund"}
                                               #:airtable.base {:id "appCqU1TJNpCn6QMM", :name "Applied Computing"}
                                               #:airtable.base {:id "appNFsjPiaMAxOiR9", :name "Job Post"}
                                               #:airtable.base {:id "appz2IfhQzYNlg6qN", :name "Untitled Base"}
                                               #:airtable.base {:id "appz0ZXy0dTaBh4Qc", :name "Connectd"}
                                               #:airtable.base {:id "appuAYJzlZjsIJUdI", :name "Liddy Full Stack Engineer"}
                                               #:airtable.base {:id "app7ThVN3xkJhPmiV", :name "Untitled Base"}],
                        :bases-response-error nil}
         tables #:airtable.base
                        {:tables [#:airtable.table {:id "tblN8a0bFG1VDQ7sF", :name "Client Pipeline"}
                                  #:airtable.table {:id "tbl9Zxg6E9r2H9E0F", :name "Communities"}
                                  #:airtable.table {:id "tbl9Zxg6E9r2Heueu", :name "A very, very, extremely long and descriptive table name that wants to wrap on several lines"}
                                  ],
                         :tables-response-error nil}]
     (for [{:connection/keys [uuid description]} (:user/connections connections)]
       ^{:key uuid}
       [:div {:style {:margin-left "20px" :background-color "#ffefef" :width "600px"}}
        [:input {:type  "radio"
                 :name  "connections"
                 :value uuid
                 :id uuid
                 }]
        [:label {:for uuid} (str " " description)]
        [:div (when (= uuid  #uuid "ad2fd7c0-8175-4d48-adfe-3dbd8846b262")
                [:div [:h2 {:style {:margin-left "20px" :background-color "#ccf" :font-weight "bold" :font-size "1.3em"
                                    }} "Select a base to view its tables"]
                 (for [{:airtable.base/keys [id name]} (:airtable/bases bases)]
                  ^{:key id}
                  [:div
                   {:style {:margin-left "20px" :background-color "#efefff"}}
                   [:input {:type  "radio"
                            :name  "bases"
                            :value id
                            :id    id
                            }]
                   [:label {:for id} (str " " name)]
                   [:div (when (= name "gingerbread BD")
                           [:div {:style {:margin-left "20px" :background-color "#efffef"}}
                            [:h3 {:style {:background-color "#cfc" :font-weight "bold" :font-size "1.1em"}}
                            "Select a table to view its contents and select the lookup column(s)"]
                            (for [{:airtable.table/keys [id name]} (:airtable.base/tables tables)]
                             ^{:key id}
                             [:div
                              {:style { :background-color "#efffef"}}
                              [:input {:type  "radio"
                                       :name  "tables"
                                       :value id
                                       :id    id
                                       }]
                              [:label {:for id} (str " " name)]
                              ]
                             )])]

                   ]
                  )])]]))
   [c/Button
     {:on-click #(>e [:routing/navigate [:data-tasks-new/select-match-fields]])}
     "Connect and See Sample Data"]])

(defn match-fields-selection-view
  []
  [layout/page
   [layout/title-bar
    [c/Heading "Select the columns that we'll use to do the magic"]]
   [:div "SAMPLE DATA HERE"]
   [:div "A way to choose column(s) that will be the match fields"]
   [c/Button
     {:on-click #(>e [:routing/navigate [:data-tasks-new/review]])}
     "Review your task next!!! ALMOST THERE BUOIIIIIII!!!"]])

(defn review-task-view
  []
  [layout/page
   [layout/title-bar
    [c/Heading "Todo bien? Todo correcto???"]]
   [:div "Matched columns are displayed and stuff"]
   [c/Button
     {:on-click #(>e [:routing/navigate [:data-tasks/all]])}
     "SAVE and go back to the list"]])

(def all
  [["/data-tasks"
    {:name :data-tasks/all
     ::routing/window-title "Data Tasks"
     :view all-tasks-view}]
   ["/data-tasks/new"
    {:name :data-tasks/new
     ::routing/window-title "New Data Task"
     :view new-task-view}]
   ["/data-tasks/new/connection"
    {:name :data-tasks-new/connection
     ::routing/window-title "New Data Task · Connection"
     :view connection-setup-view}]
   ["/data-tasks/new/match-fields"
    {:name :data-tasks-new/select-match-fields
     ::routing/window-title "New Data Task · Match Fields"
     :view match-fields-selection-view}]
   ["/data-tasks/new/review"
    {:name :data-tasks-new/review
     ::routing/window-title "New Data Task · Review"
     :view review-task-view}]])
